// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-Nn0","colMin":"styles_colMin__2vZpL"};